import { render, staticRenderFns } from "./viewSingleTouchpointAnalytics.vue?vue&type=template&id=8df13420"
import script from "./viewSingleTouchpointAnalytics.vue?vue&type=script&lang=js"
export * from "./viewSingleTouchpointAnalytics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports